import { normalizeTagValue } from './tagUtils';

export const TAG_GROUPS = Object.freeze([
    { id: 'media-narrative-influence', label: 'Media, Narrative & Influence' },
    { id: 'power-politics-global-affairs', label: 'Power, Politics & Global Affairs' },
    { id: 'culture-identity-society', label: 'Culture, Identity & Society' },
    { id: 'religion-belief-spiritual-traditions', label: 'Religion, Belief & Spiritual Traditions' },
    { id: 'secret-organizations-symbolic-power-esotericism', label: 'Secret Organizations, Symbolic Power & Esotericism' },
    { id: 'history-cycles-critical-frameworks', label: 'History, Cycles & Critical Frameworks' },
    { id: 'technology-systems-human-futures', label: 'Technology, Systems & Human Futures' },
    { id: 'uncategorized-others', label: 'Uncategorized Others' },
]);

const sortTags = (tags) => (
    [...tags].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
);

export const deriveTagGroupDefinitions = (rawGroups = []) => {
    const source = Array.isArray(rawGroups) ? rawGroups : [];
    const unique = [];
    const seen = new Set();

    source.forEach((group, index) => {
        if (!group) {
            return;
        }

        const id = typeof group.id === 'string'
            ? group.id.trim()
            : (typeof group.key === 'string' ? group.key.trim() : '');

        if (!id || seen.has(id)) {
            return;
        }

        seen.add(id);

        const label = typeof group.label === 'string' ? group.label.trim() : `Tag ${index + 1}`;
        unique.push({ id, label });
    });

    return unique;
};

export const buildTagGroups = (rawGroups = [], groups = TAG_GROUPS) => {
    const groupArray = Array.isArray(groups) && groups.length > 0 ? groups : TAG_GROUPS;
    const rawArray = Array.isArray(rawGroups) ? rawGroups : [];

    const rawById = new Map();
    rawArray.forEach((group) => {
        if (!group) {
            return;
        }
        const id = typeof group.id === 'string'
            ? group.id.trim()
            : (typeof group.key === 'string' ? group.key.trim() : '');
        if (!id) {
            return;
        }
        rawById.set(id, group);
    });

    return groupArray.map((group, index) => {
        const rawGroup = rawById.get(group.id);
        const rawSubTags = rawGroup?.subTags ?? rawGroup?.tags ?? [];

        const canonical = new Map();
        (Array.isArray(rawSubTags) ? rawSubTags : []).forEach((tag) => {
            if (tag == null) {
                return;
            }
            const label = String(tag).trim();
            const normalized = normalizeTagValue(label);
            if (!normalized || canonical.has(normalized)) {
                return;
            }
            canonical.set(normalized, label);
        });

        return {
            id: group.id || `tag-${index + 1}`,
            label: rawGroup?.label || group.label || `Tag ${index + 1}`,
            subTags: sortTags([...canonical.values()]),
        };
    });
};

export const buildTagGroupsFromRaw = (rawGroups = []) => {
    const defs = deriveTagGroupDefinitions(rawGroups);
    if (defs.length === 0) {
        return [];
    }
    return buildTagGroups(rawGroups, defs);
};
